"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchPortalCurrencyInfoRequestStatus = exports.getSyncROISettingRequestStatus = exports.getSyncCostPerLeadRequestStatus = exports.getFetchCostPerLeadRequestStatus = exports.getPortalCurrency = exports.getDesiredCostPerLead = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getDesiredCostPerLead = function getDesiredCostPerLead(state) {
  return state.modules.marketing.ads.entities.roiSettings.desiredCostPerLead;
};

exports.getDesiredCostPerLead = getDesiredCostPerLead;

var getPortalCurrency = function getPortalCurrency(state) {
  return state.modules.marketing.ads.entities.roiSettings.get('portalCurrency');
};

exports.getPortalCurrency = getPortalCurrency;
var getFetchCostPerLeadRequestStatus = (0, _getRequestStatus.default)(_actions.AdsROIActionTypes.FETCH_COST_PER_LEAD);
exports.getFetchCostPerLeadRequestStatus = getFetchCostPerLeadRequestStatus;
var getSyncCostPerLeadRequestStatus = (0, _getRequestStatus.default)(_actions.AdsROIActionTypes.SYNC_COST_PER_LEAD);
exports.getSyncCostPerLeadRequestStatus = getSyncCostPerLeadRequestStatus;
var getSyncROISettingRequestStatus = (0, _getRequestStatus.default)(_actions.AdsROIActionTypes.SYNC_ROI_SETTING);
exports.getSyncROISettingRequestStatus = getSyncROISettingRequestStatus;
var getFetchPortalCurrencyInfoRequestStatus = (0, _getRequestStatus.default)(_actions.AdsROIActionTypes.FETCH_PORTAL_CURRENCY_INFO);
exports.getFetchPortalCurrencyInfoRequestStatus = getFetchPortalCurrencyInfoRequestStatus;